import { Action } from 'redux';

import AnyArrayData from '../interfaces/AnyArrayData';
import ActionPayloadAnyArrayData from '../interfaces/actions/ActionPayloadAnyArrayData';

import * as Const from '../constants';

export const fetchMapInit = (): Action => {
  return {
    type: Const.FETCH_MAP_INIT,
  };
};

export const fetchMapPending = (): Action => {
  return {
    type: Const.FETCH_MAP_PENDING,
  };
};

export const fetchMapSuccess = (payload: AnyArrayData): ActionPayloadAnyArrayData => {
  return {
    type: Const.FETCH_MAP_SUCCESS,
    payload,
  };
};

export const fetchMapFail = (): Action => {
  return {
    type: Const.FETCH_MAP_FAIL,
  };
};

export const fetchMapShow = (): Action => {
  return {
    type: Const.FETCH_MAP_SHOW,
  };
};

export const fetchMapHide = (): Action => {
  return {
    type: Const.FETCH_MAP_HIDE,
  };
};
